export function languageToggler() {
    const langToggleBtn = document.querySelector("[data-lang-toggle]");

    if(!langToggleBtn) return;
    
    const langDropdown = langToggleBtn.nextElementSibling;

    langToggleBtn.addEventListener("click", () => {
        if (!langDropdown.classList.contains("active")) {
            langDropdown.classList.add("active");
            langDropdown.setAttribute("aria-expanded", "true");

            setTimeout(() => {
                langDropdown.classList.add("fade-in");
            }, 10);
        } else {
            langDropdown.classList.remove("fade-in");
            langDropdown.setAttribute("aria-expanded", "false");

            setTimeout(() => {
                langDropdown.classList.remove("active");
            }, 310);
        }
    });
}

